<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3>{{ 'ASSIGN_ACCESS' | translate }}</h3>
  <p class="subtitle">{{ 'PROFILE_POPUP_SELECT_BUILDING_TO_ASSIGN' | translate }}</p>

  <div class="building-list">
    <p *ngIf="!buildings?.length" class="empty" role="status">
      {{ 'NO_BUILDING_IN_THIS_SITE' | translate }}
    </p>
    <button
      *ngFor="let building of buildings"
      type="button"
      class="building"
      [class.selected]="selectedBuilding?.buildingId === building.buildingId"
      [disabled]="isLoading"
      (click)="selectBuilding(building)"
    >
      <span class="building-icon" aria-hidden="true">
        <img src="assets/svg/ico-building-gray.svg" alt="" />
      </span>
      <span class="building-name" [title]="building.buildingName">{{ building.buildingName }}</span>
      <img class="chevron" src="assets/svg/ico-chevron-forward-outline.svg" alt="" aria-hidden="true" />
    </button>
  </div>
</section>
